export default __webpack_public_path__ + "static/media/Captain's Vambraces of the Shining Sun.634ba7a7.jpg";